import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { X, Loader2, ScrollText } from 'lucide-react';
import { fmtDateTime } from './shared';

const API = `${window.__BACKEND_URL__}/api`;

const ACTION_LABELS = {
  worker_submitted: 'Worker submitted & certified',
  worker_resubmitted: 'Worker resubmitted correction',
  supervisor_approved: 'Supervisor approved',
  supervisor_returned: 'Supervisor returned',
  payroll_approved: 'Payroll approved',
  payroll_flagged: 'Payroll flagged exception',
  payroll_sent_back: 'Payroll sent back',
  locked: 'Locked for pay period',
  exported_to_payroll: 'Exported to payroll',
  time_edited: 'Time edited',
  exception_resolved: 'Exception resolved',
  exception_overridden: 'Exception overridden',
  break_started: 'Break started',
  break_ended: 'Break ended',
  allocation_added: 'Allocation added',
  allocation_updated: 'Allocation updated',
  allocation_deleted: 'Allocation deleted',
};

export const AuditPanel = ({ token, entry, onClose }) => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    axios.get(`${API}/time/${entry.id}/audit-log`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setRows(data.entries || []))
      .catch(() => setRows([]));
  }, [entry.id, token]);

  return (
    <>
      <div className="fixed inset-0 bg-black/50 z-[60]" onClick={onClose} data-testid="audit-panel-overlay" />
      <aside className="fixed top-0 right-0 h-full w-full sm:w-[420px] z-[61] overflow-y-auto shadow-2xl"
        style={{ background: '#0F1923', borderLeft: '1px solid #2D3748' }}
        data-testid="audit-panel">
        <div className="sticky top-0 flex items-center justify-between p-4"
          style={{ background: '#0F1923', borderBottom: '1px solid #2D3748' }}>
          <div className="flex items-center gap-2">
            <ScrollText className="w-5 h-5" style={{ color: '#1E88E5' }} />
            <div>
              <h3 className="text-white font-semibold text-sm">Audit Trail</h3>
              <p className="text-[11px]" style={{ color: '#64748B' }}>{entry.worker_name || entry.user_name || ''} · {fmtDateTime(entry.clock_in)}</p>
            </div>
          </div>
          <button onClick={onClose} className="p-2 rounded-lg" style={{ color: '#A0AEC0' }} data-testid="audit-panel-close">
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-4">
          {rows === null ? (
            <div className="py-10 text-center"><Loader2 className="w-6 h-6 animate-spin mx-auto" style={{ color: '#1E88E5' }} /></div>
          ) : rows.length === 0 ? (
            <p className="text-sm text-center py-8" style={{ color: '#64748B' }} data-testid="audit-empty">No audit history for this entry yet.</p>
          ) : (
            <ol className="relative ml-2 space-y-4" style={{ borderLeft: '1px solid #2D3748' }} data-testid="audit-timeline">
              {rows.map((r, i) => (
                <li key={r.id || i} className="ml-4" data-testid={`audit-row-${i}`}>
                  <span className="absolute -left-[5px] mt-1.5 w-2.5 h-2.5 rounded-full" style={{ background: '#1E88E5' }} />
                  <p className="text-sm text-white font-semibold">{ACTION_LABELS[r.action] || r.action}</p>
                  <p className="text-xs" style={{ color: '#A0AEC0' }}>
                    {r.performed_by_name || 'System'} · {r.performed_at ? fmtDateTime(r.performed_at) : ''}
                  </p>
                  {r.reason && <p className="text-xs mt-1 italic" style={{ color: '#FBBF24' }}>Reason: {r.reason}</p>}
                  {r.notes && <p className="text-xs mt-1" style={{ color: '#64748B' }}>{r.notes}</p>}
                  {r.payroll_batch_reference && <p className="text-xs mt-1 font-mono" style={{ color: '#64748B' }}>Batch: {r.payroll_batch_reference}</p>}
                </li>
              ))}
            </ol>
          )}
        </div>
      </aside>
    </>
  );
};

export default AuditPanel;
